module.exports = __webpack_public_path__ + "fonts/Mukta-600-latin-ext14.df4d1a4.woff2";